import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};
const postPetFormImagesSlice = createSlice({
  name: "postPetFormImages",
  initialState,
  reducers: {
    postPetFormImagesStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postPetFormImagesSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    postPetFormImagesDataSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },

    postPetFormImagesFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postPetFormImagesStart,
  postPetFormImagesSuccess,
  postPetFormImagesFailure,
  postPetFormImagesDataSuccess,
  clearError,
  clearMessage,
} = postPetFormImagesSlice.actions;

export default postPetFormImagesSlice.reducer;
